import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-report-scores',
  imports: [CommonModule,MatIconModule],
  templateUrl: './report-scores.html',
  styleUrl: './report-scores.scss',
})
export class ReportScores {
  @Input() showScoreBoard = false;
  @Input() overAllQualityScore: string| null = null;
  @Input() qualityScore!: any[];
}
